import { Component, inject } from '@angular/core';
import { FomentIndexValueService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  FomentIndexValueCreateDto,
  FomentIndexValueDto,
  FomentIndexValueExcelDownloadDto,
  FomentIndexValueUpdateDto,
} from '../proxy/controlling/dtos/foment-index-value';
import { FOMENTINDEXVALUE_CONFIG, FOMENTINDEXVALUE_FIELDS } from './foment-index-value.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-foment-index-value',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, FomentIndexValueService, ConfirmationService],
  templateUrl: './foment-index-value.html',
  styleUrl: './foment-index-value.scss',
})
export class FomentIndexValue extends BaseCrudComponent<
  FomentIndexValueDto,
  FomentIndexValueCreateDto,
  FomentIndexValueUpdateDto,
  FomentIndexValueExcelDownloadDto
> {
  service = inject(FomentIndexValueService);
  config = FOMENTINDEXVALUE_CONFIG;
  fields = FOMENTINDEXVALUE_FIELDS;

  protected prepareUpdateDto(data: any, selected: FomentIndexValueDto): FomentIndexValueUpdateDto {
    return {
      year: data.year,
      month: data.month,
      value: data.value,
      fomentIndexId: data.fomentIndexId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'FomentIndexValue';
  }
}
